const MS_IN_SECS = 1000

export default {
    data() {
      return {
          timer: '',
          time: 90,
          TIME_INTERVALL: 90
      }
    },
    methods:{
        mixin_startTimer(timerTime){
            if(timerTime)
                this.TIME_INTERVALL = timerTime
            this.time = this.TIME_INTERVALL
            this.timer = setInterval(this.timerFunction, MS_IN_SECS)
        },
        mixin_restartTimer(){
            this.mixin_stopTimer()
            this.mixin_time = this.TIME_INTERVALL
            this.mixin_startTimer()
        },
        mixin_stopTimer(){
            this.mixin_time = 0
            if(this.timer)
                clearInterval(this.timer)
        },
        timerFunction(){
            if(this.mixin_time < 2)
                clearInterval(this.timer)
            this.mixin_time--
        }
    },
    computed:{
        mixin_time:{
            get(){
                return this.time
            },
            set(value){
                this.time = value
            }
        }
    }
}